import React from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const TopTradersTable = ({ traders }) => {
  const handleCopy = (discordId) => {
    if (!discordId) return;
    navigator.clipboard.writeText(discordId);
  };

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell><strong>User ID</strong></TableCell>
          <TableCell><strong>Username</strong></TableCell>
          <TableCell><strong>Discord ID</strong></TableCell>
          <TableCell align="right"><strong>Trades</strong></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {traders.length === 0 ? (
          <TableRow>
            <TableCell colSpan={4}>
              <Typography
                variant="body2"
                color="text.secondary"
                align="center"
              >
                No traders found
              </Typography>
            </TableCell>
          </TableRow>
        ) : (
          traders.map((user) => (
            <TableRow key={user.user_id}>
              <TableCell>{user.user_id}</TableCell>
              <TableCell>{user.username}</TableCell>
              <TableCell>
                {user.discord_id ? (
                  <>
                    {user.discord_id}
                    <Tooltip title="Copy Discord ID">
                      <IconButton
                        size="small"
                        onClick={() => handleCopy(user.discord_id)}
                      >
                        <ContentCopyIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </>
                ) : (
                  "—"
                )}
              </TableCell>
              <TableCell align="right">{user.trade_count}</TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
};

export default TopTradersTable;
